/**
 * Onboarding API Proxy Client
 * This function submits the onboarding payload to our secure backend proxy route.
 */

const createMockSuccess = async () => {
  // Simulate network delay for frontend scaffold / preview testing
  await new Promise(resolve => setTimeout(resolve, 900));

  return {
    success: true,
    message: 'Setup submitted successfully via MOCK mode',
    submissionId: `mock_sub_${Date.now()}`,
    businessId: `mock_biz_${Date.now()}`,
    climboBusinessId: `mock_climbo_${Date.now()}`,
    nextUrl: 'https://www.repupgrade.com/'
  };
};

export const prepareClimboSetup = async (payload) => {
  const mockFlag = import.meta.env.VITE_ENABLE_MOCK_SUBMIT;
  const liveFlag = import.meta.env.VITE_ENABLE_LIVE_SUBMIT;

  // Fail-safe behavior:
  // - Mock mode is the default when env vars are missing or stale.
  // - Live submit only happens when mock is explicitly false OR live is explicitly true.
  // This prevents Netlify/Vite preview builds from accidentally hitting protected backend routes.
  const shouldUseLiveSubmit = mockFlag === 'false' || liveFlag === 'true';
  const isMockMode = !shouldUseLiveSubmit;

  console.log(`[API Proxy] Submitting onboarding payload (Mock Mode: ${isMockMode})`);

  if (isMockMode) {
    return createMockSuccess();
  }

  const headers = {
    'Content-Type': 'application/json'
  };

  // WARNING: VITE_ONBOARDING_SUBMIT_TOKEN is exposed to the frontend.
  // It is optional and only suitable for lightweight deploy gating.
  // Do not put sensitive long-term secrets in frontend VITE variables.
  // For production, this should eventually be replaced by session/auth or server-generated CSRF/session protection.
  const submitToken = import.meta.env.VITE_ONBOARDING_SUBMIT_TOKEN;
  if (submitToken) {
    headers['x-repupgrade-submit-token'] = submitToken;
  }

  try {
    const response = await fetch('/api/onboarding/submit', {
      method: 'POST',
      headers,
      body: JSON.stringify(payload)
    });

    let data = {};
    try {
      data = await response.json();
    } catch (jsonError) {
      throw new Error(`Backend returned a non-JSON response with status ${response.status}`);
    }

    if (!response.ok) {
      throw new Error(data.error || `Backend submission failed with status ${response.status}`);
    }

    return data;
  } catch (error) {
    console.error('[API Proxy] Live submit failed:', error);
    throw error;
  }
};